
import { Component, Mixins, Prop } from "vue-property-decorator";
import { BrowserKinds, BrowserUtility } from "../../../utilities";
import { DocumentEditViewMixin } from ".";

@Component
export default class DocumentsProcessViewMixin extends Mixins(DocumentEditViewMixin) {
  @Prop()
  completedTitle: string;

  data() {
    return {
      isProcessing: true,
      message: "",
    };
  }
  isProcessing: boolean;
  message: string;

  async start(message: string): Promise<void> {
    this.isProcessing = true;
    this.$logger.info(message);
  }

  async finish(message: string): Promise<void> {
    document.title = this.completedTitle; // 完了時にブラウザのタイトルを指定された物に更新する.
    this.message = message;
    this.isProcessing = false;
    this.$logger.info(this.message);
    await this.$sleep(3000);  // 3秒待つ.(メッセージが読めてIE版Kickerが終了検知できる時間として.)
    this.$closeWindow(true);
  }

  async suspend(message: string, exception: any = null): Promise<void> {
    // IEも閉じないようにしてもいい気がするが以下の理由からやめておく.
    // ・Kicker側が閉じに来る実装もあるので正常に動いてたらどちらにしても閉じてしまう.
    // ・以前発生したKickerのプロセス残りが再発する可能性があるので問題出てないなら挙動変えたくない.
    if (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
      await this.finish(message);
    }
    // 例外発生時はエラー画面を表示して終了させない.
    // 画面サイズは通常は画面毎のサイズ復元によって再設定されるが、初回表示だと設定によっては元の引きずられるので念のため800x640にしておく.
    window.resizeTo(800, 640);
    this.$suspend("処理失敗", message, exception, this.$configuration.behavior.document.processor.errorCloseIntervalMilliSeconds);
  }

  async fatal(message: string, exception: any = null): Promise<void> {
    // IEも閉じないようにしてもいい気がするが以下の理由からやめておく.
    // ・Kicker側が閉じに来る実装もあるので正常に動いてたらどちらにしても閉じてしまう.
    // ・以前発生したKickerのプロセス残りが再発する可能性があるので問題出てないなら挙動変えたくない.
    if (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
      await this.finish(message);
    }
    // 例外発生時はエラー画面を表示して終了させない.
    // 画面サイズは通常は画面毎のサイズ復元によって再設定されるが、初回表示だと設定によっては元の引きずられるので念のため800x640にしておく.
    window.resizeTo(800, 640);
    this.$fatal("処理失敗", message, exception, this.$configuration.behavior.document.processor.errorCloseIntervalMilliSeconds);
  }
}
